import type { components } from "@/api-schema";
import { VehicleValuationStatus } from "@/api-schema-enums";

type VehicleValuationRouteTarget = Pick<components["schemas"]["VehicleValuation"], "status" | "uuid">;

export function getVehicleValuationRoute(valuation: VehicleValuationRouteTarget): string {
  const suffix = valuation.status === VehicleValuationStatus.VehicleSelectionRequired ? "/select-vehicle" : "";

  return `~/fab/list/${valuation.uuid}${suffix}`;
}
